import './VideoEdu_stu_detail_feedback.scss';
import * as S from '../scss/theme';
import fnc from '../mymod/commFunction';
import fncS4 from '../mymod/commFunction4';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import HongButton from '../comm/HongButton';
import HongAudioPlayer from '../audio/HongAudioPlayer';


const VideoEdu_stu_detail_feedback = ({selectedCode}) => {
  const S3_URL = process.env.REACT_APP_S3_URL_LOCAL;
  const selectedUserInfo = useSelector((state) => state.reduxIgong.selectedUserInfo);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [list, setList] = useState([]);
  const [kind, setKind] = useState(null);
  const [mission, setMission] = useState('');
  const [content, setContent] = useState('');
  const [isRefresh, setIsRefresh] = useState(false);
  const [audioSrc, setAudioSrc] = useState('');
  const [isAutoPlay, setIsAutoPlay] = useState(false);
  const [mp3_feedback, setMp3_feedback] = useState(null);

  useEffect(() => {

    if (selectedCode) {
        const code = selectedCode;
        fncSelect_list_feedback(code)
    }
  }, [isRefresh]);

  
 async function fncPlayMp3(mp3FileName) {
    if (mp3FileName) {    
      const fullPath = await fncS4.getS3PathLong( `mp3/feedback/${mp3FileName}`);//`mp3/feedback/bd_1-1.mp3`
      // const fullPath = `${S3_URL}/mp3/feedback/${mp3FileName}`;
      setAudioSrc(fullPath);
      setIsAutoPlay(true);
    }   
  } 

  function fncSelect_list_feedback(code) {
    fnc.sendAxios('/videoEduRoutes/select/video_eduProgram_mission_feedback', { code }, (res) => {

      if (Array.isArray(res) && res.length > 0) {
        setContent(res[0].feedback);
        const mp3FileName = res[0].mp3_feedback;
        fncPlayMp3(mp3FileName);
      } else {
        setContent('');
      }
    });
  }

  

  function onRefresh() {
    setIsRefresh(!isRefresh);
  }
  
//=========================================
  return (
  <div>
    <div className='VideoEdu_stu_detail_feedback'>
      <section className='sec-main'>

      <div className='box-feedback'>
        <div className='txt-content'>
          {content}
        </div>
      </div>
                   
    
      </section> 

      <div className='box-menu'>

           <HongAudioPlayer 
                audioSrc={audioSrc} 
                autoPlay={isAutoPlay} 
                onPlayCallback={() => console.log("Dynamic audio played")} 
             />

          {/* <HongButton className='btn h-btn-gray' onClick={onRefresh} disableTime={5}>새로고침</HongButton>
          <HongButton className='btn h-btn-red' onClick={onSave}>저장하기</HongButton>
          <HongButton className='btn h-btn-sky' onClick={onDelete} >삭제하기</HongButton> */}
      </div>

    </div>


   

 
  {/* </S.Section> */}

     </div>
  );
};

export default VideoEdu_stu_detail_feedback;